__webpack_require__.p = "/product-preview-card-component/";